<template>
  <div>
    <div class="row row-inside">
      <div class="flex md12 mx-2">
        <va-button
          color="primary"
          icon="fa fa-plus"
          @click="createNewLieu()"
        >
          Nouvelle salle
        </va-button>
      </div>
      <div class="flex md12 mx-2">

        <va-data-table
          class="va-table--hoverable va-table--stripped"
          :fields="fields"
          :data="listeLieux"
          no-data-label="Aucune salle trouvée"
          :per-page="parseInt(perPage)"
        >
          <template #adresseFull="{ rowData }">
            <div>
              <div v-if="rowData.adresse">{{ rowData.adresse }}</div>
              <div v-if="rowData.complement">{{ rowData.complement }}</div>

            </div>
          </template>
          <template #actions="{ rowData }">
            <va-button
              icon="fa fa-edit"
              color="info"
              @click.stop="openLieu(rowData)"
            />
            <va-button
              icon="fa fa-trash"
              color="danger"
              @click.stop="deleteLieu(rowData)"
            />
          </template>
        </va-data-table>
      </div>
    </div>
    <va-modal
      v-model="showDeleteModal"
      title="Supprimer le lieu"
      okText="Supprimer"
      cancelText="Annuler"
      max-width="400px"
      v-on:ok="confirmdeleteLieu"
      v-on:cancel="showDeleteModal = false"
    >
      <div class="modal-content">
        <h3>Supprimer le lieu</h3>
        <p>Êtes-vous sûr de vouloir supprimer ce lieu ?</p>
      </div>
    </va-modal>

    <create-lieux
      v-model="showCreation"
      :idformation_lieux="idformation_lieux"
      @update="getListLieux"
      @create="getListLieux"
    />
  </div>
</template>

<script>
import axios from "axios";
import CreateLieux from "./create-lieux.vue";

export default {
  components: {
    "create-lieux": CreateLieux,
  },
  data() {
    return {
      perPage: 10,
      listeLieux: [],
      showDeleteModal: false,
      lieuToDelete: null,
      showCreation: false,
      idformation_lieux: null,
    }
  },
  mounted() {
    this.getListLieux();
  },
  methods: {
    createNewLieu() {
      this.idformation_lieux = null;
      this.showCreation = true;
    },
    async deleteLieu(lieu) {
      this.lieuToDelete = lieu;
      this.showDeleteModal = true;
    },
    async confirmdeleteLieu() {
      try {
        await axios.delete("/api/afpf/delete-lieu", {
          params: { idformation_lieux: this.lieuToDelete.idformation_lieux }
        });
        this.launchEpicmaxToast("Salle supprimé avec succès");
        this.getListLieux();
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.launchEpicmaxToast("Cette salle est utilisée par une ou plusieurs formations et ne peut pas être supprimé.");
        } else {
          console.error(error);
          this.launchEpicmaxToast("Erreur lors de la suppression de la salle");
        }

      } finally {
        this.showDeleteModal = false;
        this.lieuToDelete = null;
      }
    },
    openLieu(lieu) {
      this.idformation_lieux = lieu.idformation_lieux;
      this.showCreation = true;
    },

    async getListLieux() {
      try {
        let results = await axios.get("/api/afpf/liste-lieux");
        this.listeLieux = results.data;
        this.idformation_lieux = null;
      } catch (error) {
        this.launchEpicmaxToast("Erreur lors de la récupération de la liste des salles");
      }
    },
    launchEpicmaxToast(toast) {
      this.showToast(toast, {
        position: "bottom-center",
        duration: 5000,
      });
    },
  },
  computed: {
    fields() {
      return [
        {
          name: "nom",
          title: "Nom",
          sortField: "nom"
        },
        {
          name: "telephone",
          title: "Téléphone",
          sortField: "telephone"
        },
        {
          name: "email",
          title: "Email",
          sortField: "email"
        },
        {
          name: "capacite",
          title: "Capacité",
          sortField: "capacite"
        },
        {
          name: "contact",
          title: "Contact",
          sortField: "contact"
        },
        {
          name: "code_postal",
          title: "Code Postal",
          sortField: "code_postal"
        },
        {
          name: "ville",
          title: "Ville",
          sortField: "ville"
        },
        {
          name: "__slot:adresseFull",
          title: "Adresse",
        },
        {
          name: "commentaires",
          title: "Commentaires",
          sortField: "commentaires"
        },
        {
          name: "__slot:actions",
          title: "Actions",
        },
      ]
    },
  },
}
</script>

<style>
</style>